import { useTranslation } from 'react-i18next';
import Modal from '../Modal/Modal';
import './BillbeeTokenModal.scss';
import BillbeeIcon from '../../icons/billbee.svg';
import Input from '../Input/Input';
import { FormikErrors, useFormik } from 'formik';
import Button from '../Button';
import { useEffect, useState } from 'react';
import MiniLoader from '../MiniLoader/MiniLoader';

interface Props {
  isModalOpened: boolean;
  closeModal: () => void;
  onSubmit: () => void;
}

interface FormValues {
  username: string;
  password: string;
}

export default function BillbeeTokenModal({
  isModalOpened,
  closeModal,
  onSubmit,
}: Props) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  const formik = useFormik<FormValues>({
    enableReinitialize: true,
    initialValues: {
      username: '',
      password: '',
    },
    validate: (values) => {
      const errors: FormikErrors<FormValues> = {};
      if (!values.username) {
        errors.username = t('Required');
      }
      if (!values.password) {
        errors.password = t('Required');
      }

      return errors;
    },
    onSubmit: (values) => {
      setIsLoading(true);
      setTimeout(() => {
        setIsLoading(false);
        onSubmit();
      }, 1500);
    },
  });

  useEffect(() => {
    if (isModalOpened) {
      formik.resetForm();
    }
    // eslint-disable-next-line
  }, [isModalOpened]);

  return (
    <Modal
      isOpened={isModalOpened}
      close={closeModal}
      title={t('Billbee integration')}
      name='token-modal'
      isLoading={isLoading}
    >
      <div className='mx-3 pt-3 pb-4 px-3'>
        <div
          className='d-flex align-items-center fw-800 Text--20 mb-3'
          data-testid='integrations-billbee'
        >
          <img
            src={BillbeeIcon}
            alt='billbee'
            style={{
              width: 40,
              height: 40,
            }}
            className='flex-shrink-0 me-2'
          />
          <span>Billbee</span>
        </div>
        <form onSubmit={formik.handleSubmit}>
          <Input
            name='username'
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.username}
            error={formik.errors.username}
            touched={formik.touched.username}
            className='Input--BillbeeTokenModal'
            disabled={isLoading}
            placeholder={t('Billbee username')}
          />
          <Input
            name='password'
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.password}
            error={formik.errors.password}
            touched={formik.touched.password}
            className='Input--BillbeeTokenModal'
            disabled={isLoading}
            placeholder={t('Api password')}
            type='password'
          />
          <div className='row row-cols-auto gx-2 '>
            <div className='col'>
              <Button
                type='submit'
                disabled={isLoading}
                className='d-flex align-items-center'
              >
                {isLoading && (
                  <MiniLoader className='MiniLoader--sm d-flex align-items-center justify-content-center me-2 MiniLoader--gray' />
                )}
                <span>{t('Connect')}</span>
              </Button>
            </div>
            <div className='col'>
              <Button
                styling='outline'
                onClick={closeModal}
                type='button'
                disabled={isLoading}
              >
                {t('Cancel')}
              </Button>
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
}
